import type { PageEntity } from 'App/sandboxed-page/pageEntities';
import logError from 'App/babel/helpers/logError';
import { SandboxBridge } from './sandboxBridge';

// A require(), not import(): an async chunk moves @upsales/components' CSS after the app's
// own in styles.css and flips the cascade app-wide (WEB-11676). And inside the method, not
// hoisted: pageEntityActions needs the modal services and `Tools`, absent at module load.
export class AppSandboxBridge extends SandboxBridge {
	protected openEntity(entity: PageEntity, payload: unknown): void {
		Promise.resolve()
			.then(() => {
				// eslint-disable-next-line @typescript-eslint/no-var-requires
				const { openPageEntity } = require('./pageEntityActions');
				return openPageEntity(entity, payload, (url: string) => this.navigate(url));
			})
			.catch((err: unknown) => logError(err, '[sandboxBridge] openEntity failed'));
	}
}

export const sandboxBridge = new AppSandboxBridge();
